import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { AppProvider } from "utils/context";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "react-query";
import store from "store/store";
import dayjs from "dayjs";
import jalaliday from "jalaliday";

import "assets/styles/main.scss";
import "utils/locale";

dayjs.extend(jalaliday);
dayjs.calendar("jalali");

const root = ReactDOM.createRoot(document.getElementById("root"));

export const queryClient = new QueryClient();

const persistor = persistStore(store);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter scrollRestoration="manual">
        <AppProvider>
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </AppProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

serviceWorkerRegistration.register();
reportWebVitals();
